import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import { FaSpinner } from "react-icons/fa";
import TopBar from "./TopBar";
import {
  createChatRoom,
  getAllCreators,
  getAllLiveCreators,
} from "../../service/api";

function UserHome() {
  const [isLoading, setisLoading] = useState(true);
  const [profiles, setProfiles] = useState([]);
  const [liveProfiles, setLiveProfiles] = useState([]);
  const [images, setImages] = useState([]);

  const navigate = useNavigate();

  const fetchData = async () => {
    const user_data = JSON.parse(sessionStorage.getItem("userdata"));
    if (!user_data) navigate("/user/login");

    let data = await getAllCreators();
    let live = await getAllLiveCreators();
    
    var response = await axios({
      method: "get",
      url: "https://creater-app.herokuapp.com/common/randomimage",
    });
    setImages(response.data);
    setLiveProfiles(live);
    setProfiles(data);
    setisLoading(false);
  };

  useEffect(() => {
    

    fetchData();
  }, []);

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="bg flex flex-col bg h-full min-h-screen">
      <TopBar />
      {isLoading && (
              <center className="py-20 my-20">
                <FaSpinner icon="spinner" className="spinner" size={70} />
              </center>
            )}
      {liveProfiles.length > 0 && (
        <div className="p-4 w-full text-slate-100">
          <h1 className="text-2xl font-bold">Live</h1>
          <div className="w-full flex gap-5 mt-2.5">
            {liveProfiles.map((profile, index) => (
              <div
                className="flex flex-col gap-2 rounded-lg p-2 px-3 items-center cursor-pointer hover:shadow-lg transition duration-500"
                key={index}
                onClick={() =>
                  navigate(
                    `/user/creator/live/${profile.email}/${profile.room_id}`
                  )
                }
              >
                <div className="w-16 h-16 rounded-full border-4 border-green-400 p-0.5">
                  <img
                    src={"" + profile.image}
                    alt="user"
                    className="w-full h-full rounded-full object-cover object-center"
                  />
                </div>
                <h1 className="text-xl text-white">{profile.name}</h1>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="p-4 w-full text-slate-100">
        <h1 className="text-2xl font-bold">Fashion</h1>
        <div className="w-full">
          <Slider {...settings}>
            {profiles.map((profile, index) => (
              <div
                className="flex flex-col gap-5 w-1/5 rounded p-2.5 cursor-pointer hover:shadow-lg transition duration-500"
                key={index}
                onClick={() => navigate(`/user/creator/${profile.email}`)}
              >
                <div className="flex gap-2 w-full items-center">
                  <img
                    src={"" + profile.image}
                    alt="user"
                    className="w-10 h-10 rounded-full object-cover object-center"
                  />
                  <h1 className="text-lg font-semibold text-white">
                    {profile.name}
                  </h1>
                </div>
                <div className="mt-4">
                  <img
                    src={"" + profile.image}
                    alt="user"
                    className="w-full h-36 rounded-xl object-cover object-center"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <div className="p-4 w-full text-slate-100">
        <h1 className="text-2xl font-bold">Trending</h1>
        <div className="w-full">
          <Slider {...settings}>
            {profiles.map((profile, index) => (
              <div
                className="flex flex-col gap-5 w-1/4 rounded p-2.5 cursor-pointer hover:shadow-lg transition duration-500"
                key={index}
                onClick={() => navigate(`/user/creator/${profile.email}`)}
              >
                <div className="flex gap-2 w-full items-center">
                  <img
                    src={"" + profile.image}
                    alt="user"
                    className="w-10 h-10 rounded-full object-cover object-center"
                  />
                  <h1 className="text-lg font-semibold text-white">
                    {profile.name}
                  </h1>
                </div>
                <div className="mt-4">
                  <img
                    src={"" + profile.image}
                    alt="user"
                    className="w-full h-36 rounded-xl object-cover object-center"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
     
      <div className="flex flex-col gap-5 m-4">
      <div className="">
          <h1 className="text-2xl font-bold text-slate-100">
            Sign Up, Get Verified & Join the Club
          </h1>
        </div>
        <div className="flex flex-row flex-wrap w-full">

      {images.length > 0 && images.map((image, index) => {
              return (
                <div >
                  <div>
                    <img
                      src={`${image.image}`}
                      alt="user"
                      className="h-full flex gap-5 px-10 py-2"
                    />
                   
                  </div>
                  <div></div>
                </div>
              );
            })}

            
        </div>
      </div>
    </div>
  );
}

export default UserHome;
